import { useEffect } from "react";
import { useBlocker } from "react-router-dom";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Dialog from "@mui/material/Dialog";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Theme, useTheme } from "@mui/material/styles";

import { Button } from "@covertree/ui";

import environment from "@environment/variables";
import Success from "@assets/congratulation/success.webp";
import { useResetState } from "@redux/hooks";
import { StepPath } from "@routing/paths";

export function ClaimCreationSuccess() {
  const isMobile = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.only("xs")
  );
  const theme = useTheme();

  const resetState = useResetState();

  const blockRedirect = useBlocker(({ currentLocation, nextLocation }) => {
    return (
      currentLocation.pathname ===
        `/${StepPath.CLAIM_SUBMITTED_SUCCESSFULLY}` &&
      nextLocation.pathname !== `/${StepPath.POLICY_DETAILS}` &&
      currentLocation.pathname !== nextLocation.pathname
    );
  });

  useEffect(() => {
    if (blockRedirect.state === "blocked") {
      resetState();
    }
  }, [blockRedirect]);

  return (
    <Dialog fullScreen open>
      <Box
        flex="1"
        display="flex"
        justifyContent="center"
        alignItems="center"
        p={3}>
        <Container maxWidth="sm">
          <Grid
            container
            direction="column"
            justifyContent="center"
            spacing={3}>
            <Grid item>
              <img
                src={Success}
                alt="Claim created successfully."
                width={theme.spacing(23)}
                height={theme.spacing(23)}
                style={{
                  marginLeft: theme.spacing(-5),
                }}
                data-testid="check-icon"
              />
            </Grid>
            <Typography variant="h3" gutterBottom>
              Your claim has been successfully submitted
            </Typography>
            <Typography sx={{ color: theme.colors.grey2 }}>
              We&apos;re reviewing your claim as soon as possible.
            </Typography>
            <Typography sx={{ color: theme.colors.grey2 }}>
              You can track the status in your account.
            </Typography>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                role="button"
                data-testid="go-to-marketing-page-btn"
                fullWidth={isMobile}
                sx={{
                  marginTop: theme.spacing(3),
                }}
                onClick={() =>
                  window.location.assign(environment.urls.marketingPage)
                }>
                Go to Covertree.com
              </Button>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Dialog>
  );
}
